export const personFields = {
  firstname: '',
  lastname: '',
  iban: '',
  street: '',
  plz: '',
  city: '',
  function: '',
  email: '',
};

export const travelFields = {
  reason: '',
  start: '',
  destination: '',
  startDate: '',
  startTime: '',
  endDate: '',
  endTime: '',
  startDateEvent: '',
  startTimeEvent: '',
  endDateEvent: '',
  endTimeEvent: '',
  holiday: false,
  holidayDays: '',
  km: '',
  oeffis: '',
  kmFull: false,
  kmFullNote: '',
  hotel: '',
  breakfast: '',
  lunch: '',
  dinner: '',
  abroad: '',
  allowance: false,
  country: '',
  etc: [{ name: '', price: '' }],
  note: '',
};

export const countrieList = [
   { name: 'Albanien', money: 27 },
  { name: 'Armenien', money: 24 },
  { name: 'Bhutan', money: 22 },
  { name: 'Bosnien und Herzegowina', money: 26 },
  { name: 'Ecuador', money: 22 },
  { name: 'Fidschi', money: 26 },
  { name: 'Guinea-Bissau', money: 26 },
  { name: 'Indien, Chennai', money: 18 },
  { name: 'Indien, Kalkutta', money: 26 },
  { name: 'Indien, im Übrigen (außer Bangalore, Mumbai, Neu Delhi)', money: 18 },
  { name: 'Iran', money: 27 },
  { name: 'Japan (außer Tokio)', money: 27 },
  { name: 'Kasachstan', money: 27 },
  { name: 'Kosovo', money: 20 },
  { name: 'Lesotho', money: 23 },
  { name: 'Madagaskar', money: 27 },
  { name: 'Moldau, Republik', money: 21 },
  { name: 'Mongolei', money: 19 },
  { name: 'Montenegro', money: 26 },
  { name: 'Myanmar', money: 19 },
  { name: 'Namibia', money: 23 },
  { name: 'Nepal', money: 27 },
  { name: 'Nordmazedonien', money: 22 },
  { name: 'Portugal', money: 26 },
  { name: 'Russische Föderation, Moskau', money: 25 },
  { name: 'Russische Föderation, St. Petersburg', money: 23 },
  { name: 'Russische Föderation, im Übrigen', money: 23 },
  { name: 'Serbien', money: 22 },
  { name: 'Slowakische Republik', money: 27 },
  { name: 'Südafrika, Kapstadt', money: 27 },
  { name: 'Südafrika, im Übrigen (außer Johannesburg)', money: 24 },
  { name: 'Tadschikistan', money: 22 },
  { name: 'Tonga', money: 24 },
  { name: 'Tschechische Republik', money: 26 },
  { name: 'Türkei, Ankara', money: 26 },
  { name: 'Türkei, im Übrigen (außer Izmir)', money: 20 },
  { name: 'Turkmenistan', money: 23 },
  { name: 'Ukraine', money: 27 },
  { name: 'Ungarn', money: 26 },
  { name: 'Usbekistan', money: 26 },
  { name: 'Weißrussland', money: 17 }
];